module.exports = __webpack_public_path__ + "img/1_Dicks_Screen_L_1_L.3e4a7790.jpg";